<template>
  <v-container fluid grid-list-lg pa-0 ma-0>
    <v-card flat>
      <v-card-text>
        <v-container fluid pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-select
                label="Return Code"
                v-model="fields.reason"
                :items="achErrorCodes"
                item-title="reason"
                item-value="code"
                box
                hide-details
                persistent-hint
                return-object
                single-line
              >
                <template v-slot:selection="data">
                  {{ data.item.code }}: {{ data.item.reason }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.code }}: {{ data.item.reason }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs6 sm4>
              <v-menu
                ref="showDateModal"
                :close-on-content-click="false"
                v-model="showDateModal"
                :nudge-right="40"
                :return-value.sync="fields.return_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Return Date"
                  v-model="formattedDate"
                  :rules="dateRules"
                  append-icon="fa-calendar"
                  readonly
                  box
                  hide-details
                />
                <v-date-picker
                  v-model="fields.return_date"
                  :max="maximumDate"
                  :min="minimumDate"
                  @input="$refs.showDateModal.save(fields.return_date)"
                />
              </v-menu>
            </v-flex>

            <v-flex xs6 sm4>
              <v-text-field
                label="Amount"
                v-model="fields.amount"
                box
                disabled
                hide-details
                :rules="amountRules"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-divider class="primary"></v-divider>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="markReturned" :disabled="!(fields.amount && fields.return_date && fields.reason)">Mark Returned</v-btn>
          </v-layout>

        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import AchMixin from '@/mixins/ach'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [AchMixin, ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false,
      showDateModal: false,

      current_date: Moment().format('YYYY-MM-DD'),

      fields: {
        amount: 0,
        return_date: '',
        code: '',
        reason: ''
      },

      amountRules: [
        (v) => !!v || 'Amount is required'
      ],
      dateRules: [
        (v) => !!v || 'Return date is required'
      ],
      codeRules: [
        (v) => !!v || 'Return code is required'
      ],
      reasonRules: [
        (v) => !!v || 'Return reason is required'
      ]
    }
  },

  props: {
    transaction: Object
  },

  mounted () {
    if (this.transaction.request_type === 'ach' || this.transaction.request_type === 'achcredit') {
      this.fields.amount = this.transaction.modify_total_amount ? (this.transaction.modify_total_amount / 100).toFixed(2) : (this.transaction.total_amount / 100).toFixed(2)
    }
  },

  computed: {
    formattedDate () {
      return this.fields.return_date ? Moment(this.fields.return_date).format('MMM-DD-YYYY') : ''
    },
    minimumDate: function () {
      return Moment(this.transaction.settled).format('YYYY-MM-DD')
    },
    maximumDate: function () {
      return Moment().add(1, 'days').format('YYYY-MM-DD')
    }
  },

  methods: {
    async markReturned () {
      try {
        if (!this.transaction || !this.transaction.token_id) {
          throw new Error('Unable to identify transaction')
        }

        // @TODO if hasn't settled, don't save
        if (!this.transaction.settled && !this.transaction.ach_rejected) {
          throw new Error('Transaction has not yet been settled, please void and recreate to edit')
        }

        let options = {
          amount: this.fields.amount,
          return_date: this.fields.return_date,
          code: this.fields.reason.code,
          reason: this.fields.reason.reason
        }

        Bus.$emit('openWaitModal')

        let result = await this.api({
          method: 'put',
          url: `/transactions/${this.transaction.id}/ach_return`,
          data: options
        })

        if (result.data && !result.data.error) {
          Bus.$emit('openModal', {status: 'success', message: 'ACH Marked as Returned'})
          Bus.$emit('closeOptionsModal')
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          throw new Error(error)
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/AchReturn.vue